import React, { useEffect, useState, useMemo } from "react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_TablePagination,
} from 'material-react-table';
import { Box} from '@mui/material';
import { NavLink } from 'react-router-dom';

import axios from "../axios";
import { Button } from "bootstrap";
import { AddDoctorDialog } from "./Dialogues/AddDoctorDialog";

const DoctorsList = (props) => {
  const darkTheme = createTheme({
    palette: {
      mode: 'light'
    },
  });

  // State variables
  const [initialRender, setIntialRender] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [prevPageIndex, setPrevPageIndex] = useState(1);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const [pageNumber, setPageNumber] = useState(1);
  // const [startDate, setStartDate] = useState(props.startDate);
  // const [endDate, setEndDate] = useState(props.endDate);
  // const [searchedData, setSearchedData] = useState(props.searchData);
  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(50);
 

  const handleFilterChange = (args) => {
    setColumnFilters(args.currentFilterObject);
  };

  // const handleSortChange = (args) => {
  //   const { currentSortObject } = args;
  //   setSortField(currentSortObject[0]?.id || '');
  //   setSorting(currentSortObject);
  // };
  console.log(sorting);

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  // Memoized columns
  // const columns = useMemo(() => [
    const columns = useMemo(
      () => [
        {
          accessorKey: 'firstname', //access nested data with dot notation
          header: 'Name',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '200',
          enableColumnFilterModes: false,
          Cell: ({ cell }) => {
            const loginId = cell.row.original.loginId; // Access the loginId from the row data
            return (
              <NavLink
                to={`/doctorDetails/${loginId}`} // Pass the loginId as a parameter in the URL
                className="table__row__item"
                target="_blank"
              >
                {cell.getValue() || '-'}
              </NavLink>
            );
          },
        },
        {
          accessorKey: 'qualifications',
          header: 'Qualifications',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '180',
          enableColumnFilter: false,
          enableColumnFilterModes: false,
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
          accessorKey: 'hospitals', //normal accessorKey
          header: 'Hospitals',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '180',
          enableColumnFilter: false,
          enableColumnFilterModes: false,
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
          accessorKey: 'contact',
          header: 'Mobile Number',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '200',
          enableColumnFilterModes: false,
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
          accessorKey: 'loginId',
          header: 'loginId',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '250',
          enableColumnFilterModes: false,
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
          // accessorKey: 'assessmentCount',
          accessorKey: 'total_assessments',
          header: 'Total Assessments',
          // sortingFn: 'datetime', //use the built-in datetime sorting function instead of the default alphanumeric sorting function
          enableSorting: true,
          enableFiltering: false,
          enableColumnFilterModes: false,
          size: '230',
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        // {
        //   accessorKey: 'patientId',
        //   header: 'Patient ID',
        //   enableSorting: false,
        //   columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
        //   Cell: ({ cell }) => (
        //     <NavLink
        //       // to={`/patient/${cell.getValue()}/${cell.getValue()}`}
        //       // to={`/user/${cell.getValue()}`} // Adjust the link structure as per your routing
        //       className="table__row__item"
        //       target="_blank"
        //       to={`patient/${cell.row.original.userId}/${cell.getValue()}`}
        //     >
        //       {cell.getValue()}
        //     </NavLink>
        //   ),
        // },
      ],
      [],
    );

  // Material React Table hook
  const table = useMaterialReactTable({
    columns,
  
    muiPaginationProps: {
      showRowsPerPage: true,
      rowsPerPageOptions: [5, 20, 50, 100],
      showFirstButton: false,
      showLastButton: false,
    },
  
    muiTableProps: {
      sx: {
        borderCollapse: 'collapse', 
        '& td': {
          border: 'none',
          fontSize: '14px',
        },  
        '& th': {
          borderRight: '2px solid #a9a9a9',
          // borderLeft: '1px solid #606060',
          // margin:'2px 0 2px 0'
        },
      },
    },
    muiSkeletonProps: {
      animation: 'wave',
    },
    muiTableHeadCellProps: {
      sx: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '14px',
        backgroundColor: "#fdfaf0",
        minHeight: '40px',
        borderRight: '1px solid #000',
      },
    },
    muiTableBodyCellProps: {
      sx: {
        fontSize: '12px',
      },
    },
    muiTopToolbarProps:{
      sx:{
        boxSizing:"12px",
        fontSize:"14px"
      }
    },
    muiToolbarAlertBannerProps: isError
      ? {
          color: 'error', 
          children: 'Error loading data',
        }
      : undefined,
    muiTableContainerProps: { sx: { maxHeight: '600px' } },
    data,
    manualFiltering: true,
    manualSorting: true,
    enableGlobalFilter: false,
    enableSortingRemoval: true,
    enableDensityToggle: true,
    manualGrouping: true,
    pageSize: pageSize,
    manualPagination: true,
    enableFilterMatchHighlighting: false,
    columnFilterDisplayMode: 'popover',
    enableColumnFilterModes: true,
    enableFacetedValues: true,
    enableFilters: true,
    sorting: sorting,
    onSortingChange: setSorting,
    enableColumnOrdering: true,
    enableColumnResizing: true, 
  
  
    // initialState: {showColumnFilters: true, pagination: { pageSize: 50, pageIndex: 1 } },
  
    renderBottomToolbar: ({ table }) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '10px',
        
        }}
      >
        <MRT_TablePagination table={table} />
      </Box>
    ),
    
    
    isMultiSortEvent: () => false,
   
    onColumnFiltersChange: setColumnFilters,
    // onColumnFiltersChange: handleFilterChange,
  
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },
  });

  const queryParams = {
    ...columnFilters.reduce((params, filter) => {
      if (filter.id === 'contact') {
        params['mobileNumber'] = filter.value;
      } else if (filter.id === 'loginId') {
        params['userId'] = filter.value;
      } else{
        params[filter.id] = filter.value;
      }
      return params;
    }, {}),
  };

  const sortingParams = (sorting) => {
    const params = {};
  
    // Check if sorting information is provided
    if (sorting && sorting.length > 0) {
      const sortInfo = sorting[0];
      params['sort_field'] = sortInfo.id;
      params['sort_type'] = sortInfo.desc ? 'desc' : 'asc';
    }
  
    return params;
  };
  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`/getDoctors`, {
        headers: {
          accessToken: localStorage.accessToken
        },
      });

      if (response.data.message) {
        setData([]);
        setRowCount(0)
      } else {
        setData(response.data.data.users);
        setRowCount(response.data.complete_doctors_count);
        
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (initialRender) {
      setIntialRender(false);
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (!initialRender) {
      fetchPaginatedData();
    }
  }, [pagination.pageIndex]);

  useEffect(() => {
    if (!initialRender) {
      fetchPageSizeData();
    }
  }, [pagination.pageSize]);

  useEffect(() => {
    if (!initialRender) {
      fetchSortedData();
    }
  }, [sorting]);

  useEffect(() => {
    if (!initialRender) {
      fetchFilteredData();
    }
  }, [columnFilters]);

  const fetchPaginatedData = async () => {
    const nextPageIndex = pagination.pageIndex + 1;
    // const nextPage = nextPageIndex === 0 ? nextPageIndex + 1 : nextPageIndex + 1;

    if (nextPageIndex > prevPageIndex) {
      fetchNextDoctors(nextPageIndex);
    } else if (nextPageIndex < prevPageIndex) {
      fetchPreviousDoctors(nextPageIndex);
    }
    setPrevPageIndex(nextPageIndex);
  };

  const fetchPageSizeData = async () => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      const response = await axios.get(`/getDoctors`, {
        headers: { accessToken: localStorage.accessToken },
        params: {
          page_size: pagination.pageSize,
          ...queryParams,
          ...sortingParams(sorting),
        },
      });
      if(response.data.message){
        setData([]);
        setRowCount(0)
      }
      else{
        setData(response.data.data.users);
        setRowCount(response.data.complete_doctors_count);
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  const fetchSortedData = async () => {
    try {
      if (!data.length) {
        setIsLoading(true);
      } else {
        setIsRefetching(true);
      }
  
      const response = await axios.get(`/getDoctors`, {
        headers: { accessToken: localStorage.accessToken },
        params: {
          page_size: pagination.pageSize,
          ...queryParams,
          ...sortingParams(sorting),
        }
      });
  
      if (response.data.message) {
        setData([]);
        setRowCount(0);
      } else {
        setData(response.data.data.users);
        setRowCount(response.data.complete_doctors_count);
      }
  
      setIsError(false);
  
    } catch (error) {
      console.log("error", error);
      setIsError(true);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  

  const fetchFilteredData = async () => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      const response = await axios.get(`/getDoctors`, {
        headers: { accessToken: localStorage.accessToken },
        params: {
          ...queryParams,
          ...sortingParams(sorting),
          page_size: pagination.pageSize,
        },
      });
  
      if (response.data.message) {
        setData([]);
        setRowCount(0)
      } else {
        setData(response.data.data.users);
        setRowCount(response.data.complete_doctors_count);
      }
      setIsError(false);
      setIsLoading(false);
      setIsRefetching(false);
    } catch (error) {
      console.log("error", error);
      setIsError(true);
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const fetchNextDoctors = async (ind) => {
    if (isLoading) return;
    setIsLoading(true);
    
    try {
      const response = await axios.get(`/getDoctors`,{
        headers: {accessToken: localStorage.accessToken},
        params: {
          page_number: ind,
          page_size: pagination.pageSize,
          ...queryParams,
          ...sortingParams(sorting),
        },
      });
      if(response.data.message){
        setData([]);
        setRowCount(0)
      } else {
        setData(response.data.data.users);
        setRowCount(response.data.complete_doctors_count);
      }
      setIsError(false);
      setIsLoading(false);
      setIsRefetching(false);
    } catch (error) {
      console.log("error");
    }
  };

  const fetchPreviousDoctors = async (ind) => {
    setPageNumber(prevState => (prevState - 1)); 
    setPrevPageIndex(prevState => (prevState - 1));
    if (!data.length || ind <= 1) {
        setIsLoading(true);
    } else {
        setIsRefetching(true);
    }
    try {
      const response = await axios.get(`/getDoctors`,{
          headers: {accessToken: localStorage.accessToken},
          params: {
              page_number: ind,
              page_size: pagination.pageSize,
              ...queryParams,
              ...sortingParams(sorting),
          },
      });
      if(response.data.message){
        setData([]);
        setRowCount(0)
      } else {
        setData(response.data.data.users);
        setRowCount(response.data.complete_doctors_count);
      }
      setIsError(false);
      setIsLoading(false);
      setIsRefetching(false);
    } catch (error) {
      console.log("error");
    }
    };

  return (
    <div className="dashboard">
     
      <div className="dashboard__content" style={{marginTop: '45px'}} >
      <div>
      <button className="addDoctorButton"  type="button" onClick={handleOpenDialog}>Add Doctor</button>
      <AddDoctorDialog open={isDialogOpen} onClose={handleCloseDialog} />
      </div>
      
    <div>
    <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <MaterialReactTable table={table} pageSize={pagination.pageSize} />
      </ThemeProvider>  
    </div>

   
    </div>
    </div>
  );
};

export default DoctorsList;